import {getSessionManagementServiceInstance} from '~src/sessionManagement/SessionManagementService';

export module CollectionUtils {
  export const checkCollectionSiteSetting: () => (boolean) = () => {
    return getSessionManagementServiceInstance().isCollectionsEnabledOnSite();
  };
}